<template>
  <el-select
    v-if="editable && !useVuetify"
    v-model="selectedId"
    @change="do_change"
    :placeholder="placeholder"
    :size="size"
    filterable
    :multiple="multi"
    :clearable="clearable"
  >
    <el-option
      v-for="option in getLeadSources"
      :value="option.id"
      :key="option.id"
      :label="option.label"
    >
    </el-option>
  </el-select>
  <v-select
    v-else-if="editable && useVuetify"
    v-model="selectedId"
    @update:model-value="do_change"
    :label="label"
    :placeholder="placeholder"
    :items="selectOptions"
    :density="vuetifyDensity"
    hide-details="auto"
    variant="outlined"
    :clearable="clearable"
    :multiple="multi"
  ></v-select>
  <span v-else>
    {{ getSelectedLabel() }}
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'leadSourceSelect',
  computed: {
    ...mapGetters('leadSource', ['getLeadSources']),
    selectOptions() {
      return this.getLeadSources
        .filter((l) => l.is_active === true)
        .map((source) => ({
          value: source.id,
          title: source.label,
        }));
    },
    vuetifyDensity() {
      const densityMap = {
        default: 'default',
        small: 'compact',
        mini: 'comfortable',
      };
      return densityMap[this.size] || 'compact';
    },
  },
  props: {
    value: {
      type: [Number, String],
    },
    initialId: {
      type: [Number, Array],
      required: false,
    },
    size: {
      type: String,
      default: () => {
        return 'small';
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: () => {
        return 'Select a Lead Source';
      },
    },
    label: {
      type: String,
      required: false,
      default: () => {
        return 'Lead Source';
      },
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    multi: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedId: undefined,
    };
  },
  watch: {
    initialId(id) {
      this.selectedId = id;
    },
    value(n) {
      if (!this.multi) {
        this.selectedId = parseInt(n);
      }
    },
  },
  async created() {
    if (this.initialId) {
      this.selectedId = this.initialId;
    }
    if (this.value != undefined && !this.multi) {
      this.selectedId = parseInt(this.value);
    }
  },
  methods: {
    do_change() {
      if (!this.multi) {
        this.$emit(
          'update:leadSource',
          this.getLeadSources.find((s) => s.id == this.selectedId)
        );
        this.$emit('update:modelValue', this.selectedId);
        this.$emit('change', this.selectedId);
      } else {
        // Array in this case
        this.$emit('update:leadSource', this.selectedId);
        this.$emit('update:modelValue', this.selectedId);
      }
    },
    getSelectedLabel() {
      const ls = this.getLeadSources.find((s) => s.id == this.selectedId);
      return ls ? ls.label : 'None';
    },
  },
};
</script>
